(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-announcement"] && !Shopify.designMode) return;
  try {
    
  class NxMarquee extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('.nx-mq__toggle');
      if (!toggle) return;
      const flip = () => {
        const paused = this.toggleAttribute('data-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      toggle.addEventListener('click', flip);
      this.querySelector('.nx-mq__viewport')?.addEventListener('click', (event) => {
        if (!event.target.closest('a')) flip();
      });
    }
  }

  if (!customElements.get('nx-marquee')) customElements.define('nx-marquee', NxMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-before-after"] && !Shopify.designMode) return;
  try {
    
  class NxBeforeAfter extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('.nxp-ba__range');
      if (!range) return;
      const update = () => this.style.setProperty('--nx-ba-pos', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    }
  }

  if (!customElements.get('nx-before-after')) customElements.define('nx-before-after', NxBeforeAfter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-nxc-sort]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nx-header')) {
    customElements.define(
      'nx-header',
      class extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('dialog');
          this.openBtn = this.querySelector('[data-nx-open]');
          this.glass = this.classList.contains('nx-hdr--glass');
          /* Horizon, desde 990 px, hace scroll dentro de .page-wrapper y no en la ventana. */
          this.wrapper = document.querySelector('.page-wrapper');
          this.onScroll = () => {
            const y = Math.max(window.scrollY, this.wrapper?.scrollTop || 0);
            this.classList.toggle('is-scrolled', this.glass && y > 24);
          };
          this.onScroll();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.wrapper?.addEventListener('scroll', this.onScroll, { passive: true });

          this.resize = new ResizeObserver(() => {
            document.body.style.setProperty('--header-height', `${this.offsetHeight + 20}px`);
            document.body.style.setProperty('--header-group-height', `${this.offsetHeight + 20}px`);
          });
          this.resize.observe(this);

          this.openBtn?.addEventListener('click', () => this.open());
          this.drawer?.querySelector('[data-nx-close]')?.addEventListener('click', () => this.drawer.close());
          this.drawer?.addEventListener('click', (event) => {
            if (event.target === this.drawer) this.drawer.close();
          });
          this.drawer?.addEventListener('close', () => {
            this.openBtn?.setAttribute('aria-expanded', 'false');
            this.openBtn?.focus();
          });
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          this.wrapper?.removeEventListener('scroll', this.onScroll);
          this.resize?.disconnect();
        }

        open() {
          if (!this.drawer) return;
          this.drawer.showModal();
          this.openBtn?.setAttribute('aria-expanded', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-offer-countdown"] && !Shopify.designMode) return;
  try {
    
  class NxOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.nums = Object.fromEntries([...this.querySelectorAll('[data-u]')].map((el) => [el.dataset.u, el]));
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    endTime() {
      if (this.dataset.mode !== 'daily') return Number(this.dataset.end) * 1000;
      const openH = Number(this.dataset.openH);
      const closeH = Number(this.dataset.closeH);
      const d = new Date();
      const lima = new Date(d.getTime() + d.getTimezoneOffset() * 6e4 - 5 * 36e5);
      const h = lima.getHours();
      const open = openH < closeH ? h >= openH && h < closeH : h >= openH || h < closeH;
      if (!open) return 0;
      const end = new Date(lima);
      end.setHours(closeH, 0, 0, 0);
      if (end <= lima) end.setDate(end.getDate() + 1);
      return Date.now() + (end - lima);
    }

    tick() {
      const left = this.endTime() - Date.now();
      if (!Number.isFinite(left) || left <= 0) {
        window.clearInterval(this.timer);
        (this.closest('.shopify-section') || this).hidden = true;
        return;
      }
      const s = Math.floor(left / 1000);
      const days = Math.floor(s / 86400);
      const values = { d: days, h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      const dayUnit = this.querySelector('[data-unit-d]');
      if (dayUnit) dayUnit.hidden = days === 0;
      for (const [unit, el] of Object.entries(this.nums)) {
        const text = unit === 'd' ? String(values.d) : String(values[unit]).padStart(2, '0');
        if (el.textContent !== text) el.textContent = text;
      }
    }
  }

  if (!customElements.get('nx-offer-countdown')) customElements.define('nx-offer-countdown', NxOfferCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-proof-strip"] && !Shopify.designMode) return;
  try {
    
  class NxProofStrip extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('button.nxp-proof__bar');
      if (!this.dialog || !this.trigger) return;
      this.trigger.addEventListener('click', () => this.dialog.showModal());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-nx-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.trigger.focus());
    }
  }

  if (!customElements.get('nx-proof-strip')) customElements.define('nx-proof-strip', NxProofStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class NxStickyCta extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-nx-cod-trigger]');
      this.button.addEventListener('click', (event) => this.activate(event), true);
      this.watched = this.findWatched();
      if (!this.watched || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.toggle(passed);
      });
      this.observer.observe(this.watched);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.documentElement.removeAttribute('data-nx-sticky');
    }

    findWatched() {
      const selectors = (this.dataset.watch || '').split('|').map((s) => s.trim()).filter(Boolean);
      for (const selector of selectors) {
        const el = document.querySelector(selector);
        if (el && el.getBoundingClientRect().height > 0) return el;
      }
      return null;
    }

    toggle(show) {
      this.toggleAttribute('data-visible', show);
      this.button.tabIndex = show ? 0 : -1;
      const root = document.documentElement;
      if (show) {
        root.setAttribute('data-nx-sticky', 'on');
        root.style.setProperty('--nx-sticky-height', `${this.offsetHeight}px`);
      } else {
        root.removeAttribute('data-nx-sticky');
      }
    }

    activate(event) {
      const fallback = document.querySelector('[data-nx-cod-fallback]:not([hidden]) a');
      if (fallback && this.button.hasAttribute('data-nx-app-trigger')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        fallback.click();
      }
    }
  }

  if (!customElements.get('nx-sticky-cta')) customElements.define('nx-sticky-cta', NxStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  class NxUgcVideos extends HTMLElement {
    connectedCallback() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const off = document.documentElement.dataset.nxAnimation === 'off';
      this.autoplay = !reduce && !off && 'IntersectionObserver' in window;
      this.items = [...this.querySelectorAll('.nxp-vid')];

      this.items.forEach((item) => {
        const video = item.querySelector('video');
        const toggle = item.querySelector('.nxp-vid__toggle');
        if (!video || !toggle) return;
        video.addEventListener('play', () => this.sync(toggle, true));
        video.addEventListener('pause', () => this.sync(toggle, false));
        toggle.addEventListener('click', () => {
          item.dataset.userPaused = String(!video.paused);
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });
      });

      if (!this.autoplay) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && entry.target.dataset.userPaused !== 'true') {
              video.play().catch(() => {});
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        },
        { threshold: 0.6 }
      );
      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    sync(toggle, playing) {
      toggle.setAttribute('aria-pressed', String(playing));
      const label = toggle.querySelector('[data-nx-label]');
      if (label) label.textContent = playing ? this.dataset.labelPause : this.dataset.labelPlay;
    }
  }

  if (!customElements.get('nx-ugc-videos')) customElements.define('nx-ugc-videos', NxUgcVideos);

  } catch(e) { console.error(e); }
})();
})();
